<script setup>
import ShortMessageServiceTable from '@frontJs/components/tables/projectManagement/sem/ShortMessageServiceTable.vue';
import TenantReportShortMessageServiceTable from '@frontJs/components/tables/projectManagement/sem/tenantReports/ShortMessageServiceTable.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import TabLayout from '@js/components/tabs/TabLayout.vue';
import PageTitle from '@js/components/titles/PageTitle.vue';
import { h } from 'vue';

const { tenant } = defineProps({
    tenant: {
        type: Object,
        required: false,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>SMS - SEM - Gestion de projet - Datakepler</title>
    </Head>

    <PageTitle :tenant-name="tenant ? tenant.name : undefined">
        Gestion de projet - SEM - SMS
    </PageTitle>

    <ShortMessageServiceTable v-if="tenant" :tenant="tenant" />

    <TabLayout
        v-else
        :tabs="{
            all: {
                title: 'Tous',
                content: h(ShortMessageServiceTable, { all: true }),
            },
            perCustomer: {
                title: 'Par client (objectif)',
                content: h(TenantReportShortMessageServiceTable),
            },
        }"
    />
</template>
